import { fetchUnits } from "src/app/lib/useFetchUnits";
import { statesData } from "./statesData";
import { statesDataObject, transformToArray } from "../templates/design1/components/HeroSearch";
import { mapUnitTypesToSubtypes, propertyData } from "../templates/design1/components/HeroSearchComponent";
import { RawBranchLite } from "src/app/lib/fetchBranches";
import { Branch } from "./branchData";



export interface StatesData {
    [state: string]: {
        [lga: string]: string[];
    };
}

export function getMatchingAreas(
    unit_state: string[],
    unit_area: string[],
    unit_lga: string[],
    statesData: StatesData
): { [state: string]: { [lga: string]: string[] } } {
    // Validate inputs
    if (
        !Array.isArray(unit_state) ||
        !Array.isArray(unit_area) ||
        !Array.isArray(unit_lga) ||
        !statesData
    ) {
        return {};
    }

    const result: { [state: string]: { [lga: string]: string[] } } = {};
    const areaSet = new Set(unit_area.map((area) => area.toLowerCase()));
    const lgaSet = new Set(unit_lga);

    // Iterate over the provided states
    for (const state of unit_state) {
        if (statesData[state] && typeof statesData[state] === "object") {
            const stateResult: { [lga: string]: string[] } = {};

            // Iterate over LGAs relevant to the state
            for (const lga of Object.keys(statesData[state]).filter((lga) =>
                lgaSet.has(lga)
            )) {
                if (Array.isArray(statesData[state][lga])) {
                    // Filter areas case-insensitively
                    const matchedAreas = statesData[state][lga].filter((area) =>
                        areaSet.has(area.toLowerCase())
                    );

                    if (matchedAreas.length > 0) {
                        stateResult[lga] = matchedAreas;
                    }
                }
            }

            if (Object.keys(stateResult).length > 0) {
                result[state] = stateResult;
            }
        }
    }

    return result;
}
// Example usage
const unit_state = [
    "Oyo",
    "Abia",
    "Akwa Ibom"
];
const unit_area = [
    "Apete/Ayegun/Awotan",
    "Amawom",
    "Akpabom"
];
const unit_lga = [
    "Ido",
    "Ikwuano",
    "Eastern Obolo"
];

const matchedData = getMatchingAreas(unit_state, unit_area, unit_lga, statesData as unknown as StatesData);
console.log({matchedData})






// // utils/getUnits.ts
// import { fetchUnits } from "@/api"; // Replace with your real import
// import { getMatchingAreas, transformToArray } from "@/lib/area-utils";
// import { mapUnitTypesToSubtypes } from "@/lib/unit-utils";
// import { statesDataObject, propertyData } from "@/data/constants";

type UnitResult = {
    cleanedAreas: { [state: string]: { [lga: string]: string[] } }[];
    unitInfo: {
        [key: string]: string[];
    };
};



// Cache variables
let cachedUnits: UnitResult | null = null;
let cacheTimestamp: number | null = null;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes in milliseconds

export const getUnits = async (): Promise<UnitResult> => {
    const now = Date.now();
    // Check if cached and valid
    if (cachedUnits && cacheTimestamp && now - cacheTimestamp < CACHE_TTL) {
  
        return cachedUnits;
    }

    const result = await fetchUnits();
    const { unit_type, unit_sub_type, unit_state, unit_area, unit_lga } = result;
    const areas = getMatchingAreas(unit_state, unit_area, unit_lga, statesDataObject);
    const cleanedAreas = transformToArray(areas);
    const unitInfo = mapUnitTypesToSubtypes(unit_type, unit_sub_type, propertyData);
    cachedUnits = { cleanedAreas, unitInfo };
    cacheTimestamp = now;

 
    return cachedUnits;
};

// Optional: Force reset cache
export const resetUnitsCache = () => {
    cachedUnits = null;
    cacheTimestamp = null;

};




export const getShareUrl = (platform: string, shareUrl: string, title: string) => {
    switch (platform.toLowerCase()) {
        case "facebook":
            return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        case "linkedin":
            return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
        case "twitter":
            return `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`;
        case "instagram":
            // Instagram doesn’t support direct URL shares, fallback to homepage or do nothing
            return "https://instagram.com";
        case "youtube":
            return "https://youtube.com"; // no direct sharing for YouTube URLs
        case "tiktok":
            return "https://tiktok.com"; // no direct sharing for TikTok URLs
        default:
            return shareUrl;
    }
};


export const handleShareClick = async (platform: string) => {
    const shareUrl = window.location.href; // or the URL you want to share
    const shareTitle = document.title || "Check this out!";

    if (navigator.share) {
        try {
            await navigator.share({
                title: shareTitle,
                url: shareUrl,
            });
   
        } catch (error) {
            console.error("Error sharing", error);
        }
    } else {
        // Fallback: open a popup with platform-specific sharing URL
        const url = getShareUrl(platform, shareUrl, shareTitle);
        window.open(url, "_blank", "width=600,height=400");
    }
};




export function transformRawBranches(allBranches: RawBranchLite[]): Branch[] {
    return allBranches.map((item): Branch => ({
        id: item.id,
        branchName: item.branch_name,
        coverImage: item.picture,
        address: `${item.branch_address} ${item.city} ${item.local_government}, ${item.state}`,
        aboutBranch: item.branch_desc,
        branchSummary: {
            title: "Branch Summary",
            values: {
                total_staff: item.staffs_count,
                property_for_rent: item.staffs_count,
                property_for_sale: 0,
                property_for_short_let: 0,
                total_unit_managing: item.staffs_count,
                total_reviews: 0,
                completed_transaction: 0,
            },
        },
    }));
}










